export default __webpack_public_path__ + "static/media/expense-icon.dc3fd02a.svg";